import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { CoreHttpClient } from "../http-client/http-client.service";

import { LimitsReminderConfigService } from "./limits-reminder.config";
import { LimitsSummary } from "./limits-reminder.model";

/**
 * @deprecated -[fabric-deprecated] - Use limits-reminder-service from app-account instead.
 * */
@Injectable({
	providedIn: "root",
})
export class LimitsReminderService {
	constructor(
		private httpClient: CoreHttpClient,
		private config: LimitsReminderConfigService
	) {}

	/**
	 * @deprecated - [fabric-deprecated] - Use AccountAppCommand_INTERNAL.GetLimits from app-account instead
	 * */
	getCustomerLimits(): Observable<LimitsSummary> {
		return this.httpClient.get<LimitsSummary>({
			url: this.config.getLimitsSummaryEndoint(),
		});
	}
}
